// extracted by mini-css-extract-plugin
export default {"frame":"failed_frame__6BLLF","row":"failed_row__+nRD9"};